import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Wasl-Tower.webp';

const Project_one = () => {

  return (
    <>
       
             <div className='project_1_work' id="workBanner">
       
               <div className="container project_our_work">
       
                 <div className="heading">
                   <h1>Al Wasl Tower</h1>
                 </div>
       
                 <hr></hr>
                 <div className='project_section'>
                   <div className="project_section_content">
                     <h1 className="project_scope">Scope of Work</h1>
                     <p>A prominent commercial and mixed-use tower on Sheikh Zayed Road forming part of the Al Wasl development. The project
                        involved comprehensive plumbing and CHW installation works across the full height of the building.</p>
                     <p>MAIN CONTRACTOR : Arabtec</p>
                     <p>MEP CONTRACTOR : -</p>
                     <p>GEMCO SCOPE OF WORKS : Complete plumbing and CHW works</p>
                     {/* <h2 className="project_years">2014 – 2022</h2> */}
                   </div>
                   <div className='project_1_card'>
                     <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                   </div>
                 </div>
               </div>
             </div>
       
           </>

  )
}

export default Project_one